// @flow
import React, {
  // $FlowFixMe
  useMemo
} from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import mediator from "@tvg/mediator";
import type { RaceProgram } from "@tvg/types/Race";
import type { UserOptedInPromos } from "@tvg/types/User";
import RaceSelectorItem from "@fdr/atomic-ui/_organisms/RaceSelectorItem";
import ShadowScrollContainer from "@fdr/atomic-ui/_templates/ShadowScrollContainer";
import createRaceDataForHeader from "@fdr/utils/RaceHeaderUtils";

type Props = {
  currentRace?: RaceProgram,
  races: RaceProgram[],
  optedInPromos: UserOptedInPromos,
  isUserLogged: boolean,
  eventType?: string,
  derbyRaceTrackAbbr?: string
};

export const changeRace = (
  currentRaceNumber: string,
  raceNumberSelected: number,
  isDerbyDay: boolean,
  trackName: string
) => {
  mediator.base.dispatch({
    type: "TRACK_RACE_SELECTOR",
    payload: {
      currentRaceNumber: +currentRaceNumber,
      raceNumberSelected,
      trackName
    }
  });

  if (isDerbyDay) {
    const linkUrl = window
      ? `${window.location.pathname}?race=${raceNumberSelected}`
      : "";
    mediator.base.dispatch({
      type: "DERBY_HEADER_SELECTED_RACE",
      payload: {
        linkUrl,
        bannerName: "Bet Derby"
      }
    });
  }
};

const RaceSelectorListComponent = (props: Props) =>
  useMemo(() => {
    const currentTrackAbbr = get(props.currentRace, "track.trackCode");
    const isDerbyDay =
      get(props, "eventType") === "eventDay" &&
      currentTrackAbbr === get(props, "derbyRaceTrackAbbr");
    return (
      <ShadowScrollContainer>
        <ul>
          {props.races.map((race) => {
            const promos = get(race, "promos", []).map((promo) => {
              if (props.optedInPromos[promo.rootParentPromoID] !== undefined) {
                return {
                  ...promo,
                  isOptedIn: props.optedInPromos[promo.rootParentPromoID]
                };
              }
              return promo;
            });

            const raceInfo = {
              ...race,
              promos
            };

            return (
              <RaceSelectorItem
                key={`Race-${+race.raceNumber}`}
                race={raceInfo}
                raceData={createRaceDataForHeader(race)}
                changeRace={(raceNumberSelected: number) =>
                  changeRace(
                    get(props.currentRace, "raceNumber"),
                    raceNumberSelected,
                    isDerbyDay,
                    get(props.currentRace, "track.trackName")
                  )
                }
                isLogged={props.isUserLogged}
              />
            );
          })}
        </ul>
      </ShadowScrollContainer>
    );
  }, [
    props.races,
    JSON.stringify(props.optedInPromos),
    props.isUserLogged,
    JSON.stringify(props.currentRace),
    props.eventType,
    +props.derbyRaceTrackAbbr
  ]);

RaceSelectorListComponent.defaultProps = {
  races: [],
  optedInPromos: {},
  isUserLogged: false
};

export default connect((store) => ({
  currentRace: get(store, "RaceProgram.currentRace", {}),
  races: get(store, "RaceProgram.trackRaces", []),
  optedInPromos: get(store, "userData.optedInPromos", {}),
  isUserLogged: get(store, "userData.logged", false),
  eventType: get(store, "home.currentConfig"),
  derbyRaceTrackAbbr: get(store, "home.eventInfo.trackAbbr")
}))(RaceSelectorListComponent);
